// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apl {
  padding: 0px 24px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.apl__heading {
  font-family: "Rubik", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0c3058;
}
.apl__section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 25px;
}
.apl__section h2 {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #687e97;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.ap {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 32px;
  background: #ffffff;
  border: 1px solid #d7dde4;
  border-radius: 8px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.063);
  padding: 24px;
  width: 100%;
  max-width: 1140px;
  font-family: "Rubik", sans-serif;
  list-style: none;
}
.ap__content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ap__info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  width: 100%;
}
.ap__date {
  font-size: 14px;
  font-weight: 400;
  color: #687e97;
  line-height: 1.43;
  white-space: nowrap;
  flex-shrink: 0;
  align-self: flex-start;
}
.ap__info-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.ap__meta {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  min-width: 0;
  flex: 1;
}
.ap__title {
  font-size: 18px;
  font-weight: 500;
  color: #0c3058;
  text-align: start;
  line-height: 1.33;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.ap__subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #687e97;
  line-height: 1.43;
}
.ap__wave-section {
  width: 100%;
}
.ap__wave-container {
  background: #ffffff;
  border: 1px solid #d7dde4;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ap__wave-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
}
.ap__play-btn {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #0068f5;
  border: none;
  cursor: pointer;
  touch-action: manipulation;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}
.ap__play-btn.play {
  padding-left: 11px;
}
.ap__play-btn:hover:not(:disabled) {
  background-color: #0052c2;
}
.ap__play-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ap__waveform {
  flex: 1;
  min-width: 0;
  position: relative;
  cursor: pointer;
}
.ap__waveform:hover .ap__wave-hover {
  opacity: 1;
}
.ap__wave-hover {
  position: absolute;
  top: 0;
  z-index: 10;
  pointer-events: none;
  height: 100%;
  width: 0;
  background: #4d94ff;
  mix-blend-mode: color;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.ap__speed-dropdown {
  flex-shrink: 0;
}
.ap__speed-btn {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: baseline;
  direction: ltr;
  justify-content: center;
  padding: 9px 6px 4px 8px;
  border: 1px solid #ebeef2;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.063);
  cursor: pointer;
  touch-action: manipulation;
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #0c3058;
  white-space: nowrap;
  transition: background-color 0.15s ease;
}
.ap__speed-btn:hover {
  background-color: #f0f4ff;
}
.ap__speed-num {
  font-size: 16px !important;
}
.ap__speed-menu {
  min-width: 75px !important;
  width: 75px;
  padding: 0 !important;
  border: 1px solid #ebeef2 !important;
  border-radius: 4px !important;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.063) !important;
  overflow: hidden;
}
.ap__speed-menu > li:last-child .ap__speed-item {
  border-bottom: none;
}
.ap__speed-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-bottom: 1px solid #e8e8e8;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #0c3058;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.ap__speed-item:hover {
  background-color: #f0f4ff;
}
.ap__speed-item--active {
  background-color: #ebf3ff;
}
.ap__wave-time, .ap__wave-duration {
  position: absolute;
  z-index: 11;
  top: 31px;
  transform: translateY(-50%);
  pointer-events: none;
  padding: 1px 2px;
  background: #0c3058;
  color: #ffffff;
  border-radius: 2px;
  font-size: 14px;
  font-family: "Rubik", sans-serif;
  font-variant-numeric: tabular-nums;
  font-weight: 400;
  line-height: 1.14;
}
.ap__wave-time {
  inset-inline-start: 0;
}
.ap__wave-duration {
  inset-inline-end: 0;
}
.ap__controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}
.ap__share-btn {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 6px;
  border: 1px solid #bbbbcb;
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  height: 32px;
  width: 114px;
}
.ap__share-btn:hover {
  background-color: #f5f5f5;
}
.ap__share-btn--copied {
  color: #0068f5;
  border-color: #0068f5;
}
.ap__sidebar {
  width: 218px;
  height: 194px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #ffffff;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  min-height: 120px;
  text-align: center;
  align-content: center;
}
.ap__sidebar.icon {
  border: 4px solid #3386f7;
  color: #3386f7;
}
@media (max-width: 768px) {
  .ap {
    padding: 16px;
    gap: 16px;
  }
  .ap .ap__sidebar {
    width: 160px;
  }
  .ap .ap__info {
    gap: 16px;
  }
  .ap .ap__title {
    font-size: 16px;
  }
  .ap .ap__wave-container {
    padding: 12px;
  }
}
@media (max-width: 576px) {
  .ap {
    flex-direction: column;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
  }
  .ap .ap__sidebar {
    width: 100%;
    min-height: 140px;
    border-radius: 6px;
  }
  .ap .ap__info {
    flex-direction: column-reverse;
    align-items: start;
    gap: 4px;
  }
  .ap .ap__info-header {
    width: 100%;
  }
  .ap .ap__meta {
    width: 100%;
  }
  .ap .ap__title {
    font-size: 15px;
    white-space: normal;
    line-height: 1.4;
  }
  .ap .ap__subtitle {
    font-size: 13px;
  }
  .ap .ap__date {
    font-size: 12px;
  }
  .ap .ap__wave-row {
    gap: 8px;
  }
  .ap .ap__wave-container {
    padding: 10px;
    border-radius: 12px;
  }
  .ap .ap__play-btn {
    width: 36px;
    height: 36px;
  }
  .ap .ap__play-btn svg {
    width: 13px;
    height: 16px;
  }
  .ap .ap__wave-time,
  .ap .ap__wave-duration {
    font-size: 10px;
    padding: 1px 2px;
    top: 31px;
  }
  .ap .ap__speed-btn {
    width: 36px;
    height: 28px;
    font-size: 11px;
  }
  .ap .ap__speed-menu {
    right: 0;
    left: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./MiniSiteComponents/AudioPlayer/AudioPlayer.scss","webpack://./MiniSiteComponents/AudioPlayer/_variables.scss"],"names":[],"mappings":"AAMA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AALJ;AAOI;EACI,gCCaS;EDZT,eAAA;EACA,gBAAA;EACA,cCPO;ADEf;AAQI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AANR;AAQQ;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cCnBI;EDoBJ,yBAAA;EACA,sBAAA;AANZ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SCVY;EDYZ,mBCvCS;EDwCT,yBAAA;EACA,kBChBiB;EDiBjB,6CAAA;EACA,aCjBgB;EDmBhB,WAAA;EACA,iBClBkB;EDoBlB,gCC1Be;ED2Bf,gBAAA;AAZF;AAeE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAbJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SCtCU;EDuCV,WAAA;AAfJ;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,cClEY;EDmEZ,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,cChGW;EDiGX,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,cC5GY;ED6GZ,iBAAA;AApBJ;AAwBE;EACE,WAAA;AAtBJ;AAyBE;EACE,mBC5HO;ED6HP,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAxBJ;AA4BE;EACE,WChHe;EDiHf,YCjHe;EDkHf,cAAA;EACA,kBAAA;EACA,yBChJS;EDiJT,YAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;AA1BJ;AA4BI;EACI,kBAAA;AA1BR;AA6BI;EACE,yBC7Ja;ADkInB;AA8BI;EACE,YAAA;EACA,mBAAA;AA5BN;AAiCE;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA/BJ;AAiCI;EACE,UAAA;AA/BN;AAoCE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,QAAA;EACA,mBC7KY;ED8KZ,qBAAA;EACA,UAAA;EACA,6BAAA;AAlCJ;AAsCE;EACE,cAAA;AApCJ;AAuCE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBCnNO;EDoNP,6CAAA;EACA,eAAA;EACA,0BAAA;EACA,gCCjMa;EDkMb,eAAA;EACA,gBAAA;EACA,cCrNW;EDsNX,mBAAA;EACA,uCAAA;AArCJ;AAuCI;EACE,yBCvNU;ADkLhB;AAyCE;EACI,0BAAA;AAvCN;AA0CE;EACE,0BAAA;EACA,WAAA;EACA,qBAAA;EACA,oCAAA;EACA,6BAAA;EACA,wDAAA;EACA,gBAAA;AAxCJ;AA0CI;EACE,mBAAA;AAxCN;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBC5PO;ED6PP,YAAA;EACA,gCAAA;EACA,gCCzOa;ED0Ob,eAAA;EACA,gBAAA;EACA,cC7PW;ED8PX,eAAA;EACA,uCAAA;AA1CJ;AA4CI;EACE,yBC/PU;ADqNhB;AA6CI;EACE,yBCjQS;ADsNf;AAgDE;EAEE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBCnRW;EDoRX,cCzRO;ED0RP,kBAAA;EACA,eAAA;EACA,gCCtQa;EDuQb,kCAAA;EACA,gBAAA;EACA,iBAAA;AA/CJ;AAkDE;EACE,qBAAA;AAhDJ;AAmDE;EACE,mBAAA;AAjDJ;AAqDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;AAnDJ;AAuDE;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBC7TO;ED8TP,eAAA;EACA,gCCzSa;ED0Sb,eAAA;EACA,gBAAA;EACA,cC3TW;ED4TX,sCAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AArDJ;AAuDI;EACE,yBChUQ;AD2Qd;AAwDI;EACE,cC1UO;ED2UP,qBC3UO;ADqRb;AA2DE;EACE,YCvTe;EDwTf,aCvTgB;EDwThB,cAAA;EACA,kBC9Te;ED+Tf,mBCxVO;EDyVP,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AAzDJ;AA2DE;EACI,yBAAA;EACA,cC/UmB;ADsRzB;AAiEE;EAzUF;IA0UI,aAAA;IACA,SAAA;EA9DF;EAgEE;IACE,YAAA;EA9DJ;EAiEE;IACE,SAAA;EA/DJ;EAkEE;IACE,eAAA;EAhEJ;EAmEE;IACE,aAAA;EAjEJ;AACF;AAqEE;EA/VF;IAgWI,sBAAA;IACA,aAAA;IACA,SAAA;IACA,kBC3We;EDySjB;EAoEE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;EAlEJ;EAqEE;IACE,8BAAA;IACA,kBAAA;IACA,QAAA;EAnEJ;EAsEE;IACE,WAAA;EApEJ;EAuEE;IACE,WAAA;EArEJ;EAwEE;IACE,eAAA;IACA,mBAAA;IACA,gBAAA;EAtEJ;EAyEE;IACE,eAAA;EAvEJ;EA0EE;IACE,eAAA;EAxEJ;EA2EE;IACE,QAAA;EAzEJ;EA4EE;IACE,aAAA;IACA,mBAAA;EA1EJ;EA6EE;IACE,WAAA;IACA,YAAA;EA3EJ;EA6EI;IACE,WAAA;IACA,YAAA;EA3EN;EA+EE;;IAEE,eAAA;IACA,gBAAA;IACA,SAAA;EA7EJ;EAgFE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA9EJ;EAiFE;IACE,QAAA;IACA,qBAAA;EA/EJ;AACF","sourcesContent":["// -----------------------------------------------------------------\r\n// Audio Player – matches the Pencil design frame\r\n// -----------------------------------------------------------------\r\n\r\n@use 'variables' as *;\r\n\r\n.apl {\r\n    padding: 0px 24px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    &__heading {\r\n        font-family: $ap-font-family;\r\n        font-size: 28px;\r\n        font-weight: 700;\r\n        color: $ap-text-dark;\r\n    }\r\n\r\n    &__section {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 16px;\r\n        margin-bottom: 25px;\r\n\r\n        h2 {\r\n            font-family: $ap-font-family;\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n            color: $ap-text-muted;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.08em;\r\n        }\r\n    }\r\n}\r\n\r\n// Card shell\r\n.ap {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: stretch;\r\n  gap: $ap-card-gap;\r\n\r\n  background: $ap-white;\r\n  border: 1px solid $ap-border;\r\n  border-radius: $ap-border-radius;\r\n  box-shadow: 0 4px 14px 0 $ap-shadow;\r\n  padding: $ap-card-padding;\r\n\r\n  width: 100%;\r\n  max-width: $ap-card-max-width;\r\n\r\n  font-family: $ap-font-family;\r\n  list-style: none;\r\n\r\n  // -- Main content column -----------------------------------------\r\n  &__content {\r\n    flex: 1;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n\r\n  // -- Info row ----------------------------------------------------\r\n  &__info {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: $ap-card-gap;\r\n    width: 100%;\r\n  }\r\n\r\n  &__date {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: $ap-text-muted;\r\n    line-height: 1.43;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  &__info-header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 8px;\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n\r\n  &__meta {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    gap: 4px;\r\n    min-width: 0;\r\n    flex: 1;\r\n  }\r\n\r\n  &__title {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: $ap-text-dark;\r\n    text-align: start;\r\n    line-height: 1.33;\r\n    margin: 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 100%;\r\n  }\r\n\r\n  &__subtitle {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: $ap-text-muted;\r\n    line-height: 1.43;\r\n  }\r\n\r\n  // -- Waveform section --------------------------------------------\r\n  &__wave-section {\r\n    width: 100%;\r\n  }\r\n\r\n  &__wave-container {\r\n    background: $ap-white;\r\n    border: 1px solid $ap-border;\r\n    border-radius: 16px;\r\n    padding: 16px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  &__wave-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 16px;\r\n    width: 100%;\r\n  }\r\n\r\n  // -- Play / Pause button -----------------------------------------\r\n  &__play-btn {\r\n    width: $ap-play-btn-size;\r\n    height: $ap-play-btn-size;\r\n    flex-shrink: 0;\r\n    border-radius: 50%;\r\n    background-color: $ap-primary;\r\n    border: none;\r\n    cursor: pointer;\r\n    touch-action: manipulation;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: background-color 0.2s ease, opacity 0.2s ease;\r\n\r\n    &.play {\r\n        padding-left: 11px;\r\n    }\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: $ap-primary-hover;\r\n    }\r\n\r\n    &:disabled {\r\n      opacity: 0.5;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  // -- WaveSurfer canvas wrapper -----------------------------------\r\n  &__waveform {\r\n    flex: 1;\r\n    min-width: 0;\r\n    position: relative;\r\n    cursor: pointer;\r\n\r\n    &:hover .ap__wave-hover {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  // -- Hover gap overlay -------------------------------------------\r\n  &__wave-hover {\r\n    position: absolute;\r\n    top: 0;\r\n    z-index: 10;\r\n    pointer-events: none;\r\n    height: 100%;\r\n    width: 0;\r\n    background: $ap-wave-hover;\r\n    mix-blend-mode: color;\r\n    opacity: 0;\r\n    transition: opacity 0.2s ease;\r\n  }\r\n\r\n  // -- Speed selector dropdown -------------------------------------\r\n  &__speed-dropdown {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  &__speed-btn {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-flex;\r\n    align-items: baseline;\r\n    direction: ltr;\r\n    justify-content: center;\r\n    padding: 9px 6px 4px 8px;\r\n    border: 1px solid $ap-input-border;\r\n    border-radius: 4px;\r\n    background: $ap-white;\r\n    box-shadow: 0 4px 14px 0 $ap-shadow;\r\n    cursor: pointer;\r\n    touch-action: manipulation;\r\n    font-family: $ap-font-family;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    color: $ap-text-dark;\r\n    white-space: nowrap;\r\n    transition: background-color 0.15s ease;\r\n\r\n    &:hover {\r\n      background-color: $ap-hover-tint;\r\n    }\r\n  }\r\n\r\n  &__speed-num {\r\n      font-size: 16px !important;\r\n  }\r\n\r\n  &__speed-menu {\r\n    min-width: 75px !important;\r\n    width: 75px;\r\n    padding: 0 !important;\r\n    border: 1px solid $ap-input-border !important;\r\n    border-radius: 4px !important;\r\n    box-shadow: 0 4px 14px 0 $ap-shadow !important;\r\n    overflow: hidden;\r\n\r\n    > li:last-child .ap__speed-item {\r\n      border-bottom: none;\r\n    }\r\n  }\r\n\r\n  &__speed-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 40px;\r\n    padding: 0;\r\n    background: $ap-white;\r\n    border: none;\r\n    border-bottom: 1px solid $ap-divider;\r\n    font-family: $ap-font-family;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: $ap-text-dark;\r\n    cursor: pointer;\r\n    transition: background-color 0.15s ease;\r\n\r\n    &:hover {\r\n      background-color: $ap-hover-tint;\r\n    }\r\n\r\n    &--active {\r\n      background-color: $ap-active-bg;\r\n    }\r\n  }\r\n\r\n  // -- Time / Duration badges --------------------------------------\r\n  &__wave-time,\r\n  &__wave-duration {\r\n    position: absolute;\r\n    z-index: 11;\r\n    top: 31px;\r\n    transform: translateY(-50%);\r\n    pointer-events: none;\r\n    padding: 1px 2px;\r\n    background: $ap-text-dark;\r\n    color: $ap-white;\r\n    border-radius: 2px;\r\n    font-size: 14px;\r\n    font-family: $ap-font-family;\r\n    font-variant-numeric: tabular-nums;\r\n    font-weight: 400;\r\n    line-height: 1.14;\r\n  }\r\n\r\n  &__wave-time {\r\n    inset-inline-start: 0;\r\n  }\r\n\r\n  &__wave-duration {\r\n    inset-inline-end: 0;\r\n  }\r\n\r\n  // -- Controls row ------------------------------------------------\r\n  &__controls {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n    width: 100%;\r\n  }\r\n\r\n  // -- Copy-link / share button ------------------------------------\r\n  &__share-btn {\r\n    display: inline-flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 4px 8px 4px 6px;\r\n    border: 1px solid $ap-btn-border;\r\n    border-radius: 4px;\r\n    background: $ap-white;\r\n    cursor: pointer;\r\n    font-family: $ap-font-family;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: $ap-text-body;\r\n    transition: background-color 0.2s ease;\r\n    white-space: nowrap;\r\n    height: 32px;\r\n    width: 114px;\r\n\r\n    &:hover {\r\n      background-color: $ap-hover-bg;\r\n    }\r\n\r\n    &--copied {\r\n      color: $ap-primary;\r\n      border-color: $ap-primary;\r\n    }\r\n  }\r\n\r\n  // -- Sidebar -----------------------------------------------------\r\n  &__sidebar {\r\n    width: $ap-sidebar-width;\r\n    height: $ap-sidebar-height;\r\n    flex-shrink: 0;\r\n    border-radius: $ap-border-radius;\r\n    background: $ap-white;\r\n    background-size: cover;\r\n    background-position: center;\r\n    overflow: hidden;\r\n    min-height: 120px;\r\n    text-align: center;\r\n    align-content: center;\r\n  }\r\n  &__sidebar.icon {\r\n      border: 4px solid $ap-sidebar-icon-border;\r\n      color: $ap-sidebar-icon-border;\r\n  }\r\n\r\n  // ================================================================\r\n  // Responsive\r\n  // ================================================================\r\n\r\n  // -- Tablet (≤ 768px) --------------------------------------------\r\n  @media (max-width: $bp-tablet) {\r\n    padding: 16px;\r\n    gap: 16px;\r\n\r\n    .ap__sidebar {\r\n      width: 160px;\r\n    }\r\n\r\n    .ap__info {\r\n      gap: 16px;\r\n    }\r\n\r\n    .ap__title {\r\n      font-size: 16px;\r\n    }\r\n\r\n    .ap__wave-container {\r\n      padding: 12px;\r\n    }\r\n  }\r\n\r\n  // -- Mobile (≤ 576px) --------------------------------------------\r\n  @media (max-width: $bp-mobile) {\r\n    flex-direction: column;\r\n    padding: 12px;\r\n    gap: 12px;\r\n    border-radius: $ap-border-radius;\r\n\r\n    .ap__sidebar {\r\n      width: 100%;\r\n      min-height: 140px;\r\n      border-radius: 6px;\r\n    }\r\n\r\n    .ap__info {\r\n      flex-direction: column-reverse;\r\n      align-items: start;\r\n      gap: 4px;\r\n    }\r\n\r\n    .ap__info-header {\r\n      width: 100%;\r\n    }\r\n\r\n    .ap__meta {\r\n      width: 100%;\r\n    }\r\n\r\n    .ap__title {\r\n      font-size: 15px;\r\n      white-space: normal;\r\n      line-height: 1.4;\r\n    }\r\n\r\n    .ap__subtitle {\r\n      font-size: 13px;\r\n    }\r\n\r\n    .ap__date {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .ap__wave-row {\r\n      gap: 8px;\r\n    }\r\n\r\n    .ap__wave-container {\r\n      padding: 10px;\r\n      border-radius: 12px;\r\n    }\r\n\r\n    .ap__play-btn {\r\n      width: 36px;\r\n      height: 36px;\r\n\r\n      svg {\r\n        width: 13px;\r\n        height: 16px;\r\n      }\r\n    }\r\n\r\n    .ap__wave-time,\r\n    .ap__wave-duration {\r\n      font-size: 10px;\r\n      padding: 1px 2px;\r\n      top: 31px;\r\n    }\r\n\r\n    .ap__speed-btn {\r\n      width: 36px;\r\n      height: 28px;\r\n      font-size: 11px;\r\n    }\r\n\r\n    .ap__speed-menu {\r\n      right: 0;\r\n      left: auto !important;\r\n    }\r\n  }\r\n}\r\n","// -----------------------------------------------------------------\r\n// Audio Player – Design tokens\r\n// -----------------------------------------------------------------\r\n\r\n// Colors\r\n$ap-white: #ffffff;\r\n$ap-border: #d7dde4;\r\n$ap-shadow: rgba(0, 0, 0, 0.063);\r\n$ap-primary: #0068f5;\r\n$ap-primary-hover: #0052c2;\r\n$ap-text-dark: #0c3058;\r\n$ap-text-muted: #687e97;\r\n$ap-text-body: #333333;\r\n$ap-hover-tint: #f0f4ff;\r\n$ap-hover-bg: #f5f5f5;\r\n$ap-active-bg: #ebf3ff;\r\n$ap-divider: #e8e8e8;\r\n$ap-input-border: #ebeef2;\r\n$ap-btn-border: #bbbbcb;\r\n$ap-wave-top: #b5c0cc;\r\n$ap-wave-reflection: #d7dde4;\r\n$ap-wave-divider: #e8ecf0;\r\n$ap-wave-hover: #4d94ff;\r\n$ap-sidebar-bg: #d7dde4;\r\n$ap-sidebar-icon-border: #3386f7;\r\n\r\n// Typography\r\n$ap-font-family: 'Rubik', sans-serif;\r\n\r\n// Sizing\r\n$ap-border-radius: 8px;\r\n$ap-card-padding: 24px;\r\n$ap-card-gap: 32px;\r\n$ap-card-max-width: 1140px;\r\n$ap-sidebar-width: 218px;\r\n$ap-sidebar-height: 194px;\r\n$ap-play-btn-size: 40px;\r\n\r\n// Breakpoints\r\n$bp-tablet: 768px;\r\n$bp-mobile: 576px;\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
